import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }
export default {
  path: '/workbench',
  name: 'workbench',
  meta,
  redirect: { name: 'workbench/task' },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'status',
      name: `${pre}status`,
      component: _import('workbench/index'),
      meta: {
        title: '工作台-部门动态'
      }
    },
    {
      path: 'task',
      name: `${pre}task`,
      component: _import('workbench/task'),
      meta: {
        title: '协作任务'
      }
    },
    {
      path: 'task/my',
      name: `${pre}taskmy`,
      component: _import('workbench/task'),
      meta: {
        title: '协作任务'
      }
    },
    {
      path: 'invitation',
      name: `${pre}invitation`,
      component: _import('workbench/task/invitationList'),
      meta: {
        title: '邀请转发'
      }
    },
    {
      path: 'invitationInfo',
      name: `${pre}invitationInfo`,
      component: _import('workbench/task/invitation'),
      meta: {
        title: '邀请转发详情'
      }
    },
    {
      path: 'task/add',
      name: `${pre}task-add`,
      component: _import('workbench/task/add'),
      meta: {
        title: '添加任务'
      }
    },
    {
      path: 'launchTask',
      name: `${pre}launchTask`,
      component: _import('workbench/task/launchTask'),
      meta: {
        title: '添加任务'
      }
    },
    {
      path: 'task/edit',
      name: `${pre}task-edit`,
      component: _import('workbench/task/edit'),
      meta: {
        title: '编辑任务'
      }
    },
    {
      path: 'task/view',
      name: `${pre}task-view`,
      component: _import('workbench/task/view'),
      meta: {
        title: '查看任务'
      }
    }
  ])('workbench/')
}
